module.exports = __webpack_public_path__ + "store/img/icon_handheart@3x.d4ab4ca0.png";